import {DownloadStateType} from './types';
import {DefaultInitialData} from '../../actions/actionsTypes';

export const DefaultDownloadState: DownloadStateType = {
    desktopDownloadLinks: DefaultInitialData,
}